import request from '@/utils/request'

// 查询文章管理列表
export function listArticles(query) {
  return request({
    url: '/system/articles/list',
    method: 'get',
    params: query
  })
}
//查询心理活动动态
export function listActivity(query) {
  return request({
    url: '/psychologicalService/activityNews/listPhone',
    method: 'get',
    params: query
  })
}
// 查询心理活动动态详细
export function getActivity(id) {
  return request({
    url: '/psychologicalService/activityNews/' + id,
    method: 'get'
  })
}
// 查询文章管理详细
export function getArticles(id) {
  return request({
    url: '/system/articles/' + id,
    method: 'get'
  })
}

// 新增文章管理
export function addArticles(data) {
  return request({
    url: '/system/articles',
    method: 'post',
    data: data
  })
}

// 修改文章管理
export function updateArticles(data) {
  return request({
    url: '/system/articles',
    method: 'put',
    data: data
  })
}

// 删除文章管理
export function delArticles(id) {
  return request({
    url: '/system/articles/' + id,
    method: 'delete'
  })
}

// 导出文章管理
export function exportArticles(query) {
  return request({
    url: '/system/articles/export',
    method: 'get',
    params: query
  })
}

// 手机端判断是否完善信息
export function phonePerfect(data) {
  return request({
    url: '/system/user/phonePerfect',
    method: 'post',
    params: data
  })
}

// 查询公告详细
export function getNotice(noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'get'
  })
}

// 查询轮播图列表
export function listCarousel(query) {
  return request({
    url: '/system/carousel/list',
    method: 'get',
    params: query
  })
}